import { render, staticRenderFns } from "./ExchangeHKDDialog.vue?vue&type=template&id=68b941a3&scoped=true"
import script from "./ExchangeHKDDialog.vue?vue&type=script&lang=js"
export * from "./ExchangeHKDDialog.vue?vue&type=script&lang=js"
import style0 from "./ExchangeHKDDialog.vue?vue&type=style&index=0&id=68b941a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b941a3",
  null
  
)

export default component.exports